import { defineComponent as _defineComponent } from 'vue'
import { useVuelidate } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import { AxiosError } from 'axios';
import { computed, ref } from 'vue';

import validateState from '@/composables/validateState';
import api from '~api/api';
import GoogleRecaptcha from '~component/GoogleRecaptcha.vue';
import SubmitButton from '~component/SubmitButton.vue';
import VoucherInput from '~component/VoucherInput.vue';
import { t } from '~i18n';
import ApiErrorMessage from '~widget/ApiErrorMessage';


export default /*#__PURE__*/_defineComponent({
  __name: 'HelpForm',
  props: {
  url: {
    type: String,
    required: true,
  },
  withEmail: {
    type: Boolean,
    default: false,
  },
},
  emits: ['response'],
  setup(__props, { emit }) {

const props = __props





const loading = ref(false);
const apiSuccess = ref(false);
const apiError = ref(null as AxiosError | null);

const validationEnabled = ref(false);

const googleRecaptcha = ref(null as unknown as GoogleRecaptchaModel);

const form = ref({
  code: '',
  captcha: '',
});

const customerEmail = ref({ email: '', repeatEmail: '' });

const rules = {
  email: {
    required,
    email,
    emailDoesNotEndWithRu: (value: string) => value !== null && !value.endsWith('.ru'),
  },
  repeatEmail: {
    required,
    sameAsEmail: (value: string) => value !== null && value === customerEmail.value.email,
  },
};

const v$ = useVuelidate(rules, customerEmail);

const state = (v: string) => validateState(v, v$);

async function sendRequest(): Promise<void> {
  loading.value = true;
  apiError.value = null;
  apiSuccess.value = false;

  await api
    .post(props.url, {
      ...form.value,
      ...(props.withEmail ? customerEmail.value : {}),
    })
    .then((response) => {
      apiSuccess.value = true;
      emit('response', response.data);
    })
    .catch((error: AxiosError) => {
      apiError.value = error?.response?.data?.errors || { code: error?.response?.status };
      googleRecaptcha?.value?.reset?.();
    })
    .then(() => {
      setTimeout(() => {
        loading.value = false;
      }, 500);
    });
}

const validCode = computed((): boolean => form.value.code.length >= 11);

const isValid = (): boolean => {
  switch (true) {
    case !googleRecaptcha?.value?.validate?.():
    case props.withEmail && v$.value.$invalid:
    case !validCode.value:
      return false;

    default:
      return true;
  }
};

function trySubmit(): void {
  validationEnabled.value = true;
  form.value.captcha = googleRecaptcha?.value?.getResponse?.();
  v$.value.$touch();

  if (isValid()) {
    sendRequest();
  }
}

return { __sfc: true,props, emit, loading, apiSuccess, apiError, validationEnabled, googleRecaptcha, form, customerEmail, rules, v$, state, sendRequest, validCode, isValid, trySubmit, email, required, GoogleRecaptcha, SubmitButton, VoucherInput, t, ApiErrorMessage }
}

})